import { has as _has } from "lodash-es";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import * as yup from "yup";

import { resetUserPassword } from "../actions/user";

import Loading from "../components/Loading";
import LabeledFormField from "../components/LabeledFormField";
import Button from "../components/Button";
import Alert from "../components/Alert";

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (email) => dispatch(resetUserPassword(email)),
});

export function ResetPassword(props) {
  const [showLoader, setShowLoader] = useState(false);
  const [resetMailSent, setResetMailSent] = useState(false);

  const validationSchema = yup.object().shape({
    email: yup.string().required("Email is required"),
  });

  function onSubmit({ email }, actions) {
    setShowLoader(true);

    props.resetPassword(email).then((action) => {
      if (action.error) {
        const response = action?.error?.response?.data?.response;
        setShowLoader(false);
        if (_has(response, "errors")) {
          actions.setErrors({
            email: response.errors.email,
          });
          actions.setSubmitting(false);
        }
      } else {
        setResetMailSent(true);
      }
    });
  }

  if (resetMailSent) {
    return (
      <Alert color="success">
        Instructions to reset your password have been sent
      </Alert>
    );
  }

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 mt-3">
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl mb-3">Reset Your password</h1>
        <Formik
          initialValues={{
            email: "",
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <LabeledFormField
                label="Email"
                type="text"
                name="email"
                tabIndex="1"
              />
              <div>
                <Button
                  className="mt-4"
                  type="submit"
                  disabled={isSubmitting || showLoader}
                >
                  Reset Password
                  {showLoader && (
                    <div className="text-center ml-1 relative top-0.5">
                      <Loading />
                    </div>
                  )}
                </Button>
                &nbsp; or &nbsp;
                <Link to="/sign-in">
                  <Button type="button" intent="nooutline">
                    Sign in
                  </Button>
                </Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

ResetPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(ResetPassword);
